export default "__VITE_ASSET__c73fac5f__"